module.exports = __webpack_public_path__ + "img/transport_top2.5bbab1da.png";